import { NgOptimizedImage } from '@angular/common';
import {
  Component,
  inject,
  Input,
  ChangeDetectionStrategy,
} from '@angular/core';
import { RouterLink } from '@angular/router';
import { Layout } from 'src/app/models/layout/layout.model';
import { ImageWidthPipe } from 'src/app/pipes/image-height.pipe';
import { ImagePipe } from 'src/app/pipes/image.pipe';
import { SanitizeHtmlPipe } from 'src/app/pipes/safe-html.pipe';
import { SettingsService } from 'src/app/services/settings.service';

@Component({
  selector: 'app-header-logo',
  imports: [
    SanitizeHtmlPipe,
    RouterLink,
    NgOptimizedImage,
    ImagePipe,
    ImageWidthPipe,
  ],
  templateUrl: './header-logo.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './header-logo.component.scss',
})
export class HeaderLogoComponent {
  @Input() layout: Layout = new Layout();
  @Input() height: number = 50;
  settingsService = inject(SettingsService);

  pageName = this.settingsService.setting().PageName;

  hasSmallLogo(): boolean {
    const logo = this.layout.Logo;
    return !!(logo?.SvgLogoSmall || logo?.ImageSmall?.Url);
  }
}
